const initialState = {
    sections: [],
    loading: false,
    error: null,
};

const businessSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'business/get-summary/pending':
            return { ...state, loading: true, error: null };
        case 'business/get-summary/fulfilled':
            return { ...state, loading: false, sections: action.payload.data };
        case 'business/get-summary/rejected':
            return { ...state, loading: false, error: "No business summary data found." };
        default:
            return state;
    }
};

export default businessSummaryReducer;
